// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3rV3y","rightAdornment":"Header_rightAdornment__2yzim"};